// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sd-file{padding:0 !important}.sd-file .sv-action-bar{display:none !important}", ""]);
// Exports
export default exports;
